import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { SpecificationStore, SpecificationState } from './specification.store';

@Injectable({ providedIn: 'root' })
export class SpecificationQuery extends QueryEntity<SpecificationState> {
  constructor(protected store: SpecificationStore) {
    super(store);
  }
}
